import { render, staticRenderFns } from "./VipRecharge.vue?vue&type=template&id=b52973d6&scoped=true&"
import script from "./VipRecharge.vue?vue&type=script&lang=js&"
export * from "./VipRecharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52973d6",
  null
  
)

export default component.exports